import React from "react";
// import { Divider } from "@mui/material";
// import profile from "../../service/Mainservice";
import { useState } from "react";
import "../../assets/Styles/Profile.css";
import { Link, useNavigate } from "react-router";

const Profile = () => {
  const [profiledata, setprofiledata] = useState(
    JSON.parse(localStorage.getItem("Data"))
  );
  const { fullName, email, image, mobilenumber } = profiledata;

  const navigate = useNavigate();

  return (
    <>
      <div className="profileoptions">
        <li className="active_profile">
          <Link to="/Profile">Profile Info</Link>
        </li>
        <li>
          <Link to="/EditProfile">Update Profile</Link>
        </li>
        <li>
          <Link to="/ChangePassword">Change Password</Link>
        </li>
      </div>

      <div className="profiledata">
        <div className="profiledata_up" />
        <img className="profileimg" alt="profile" src={image} />
        <div>
          <p className="profiledetails">
            UserName :<span>{fullName}</span>
          </p>
          <p className="profiledetails">
            Email :<span>{email}</span>
          </p>
          <p className="profiledetails">
            Phone Numebr :<span>{mobilenumber}</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default Profile;
